module.exports = __webpack_public_path__ + "static/box-9aa6ca4024b4df55157ada5cbff0cd2e.jpeg";